'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var core = {};

exports.__exports = core;
